import React, { useReducer, useState } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { getRemotedbUrl, i18nIntl, isNotEmpty } from '../../lib/ep.js';
import { injectIntl } from 'react-intl';
import { useOwner } from '../context/context.js';

import OwnerPromoWrapper from '../ui_items/OwnerPromoWrapper.js';

import { SecondaryButton } from '../builder/ActionButton.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import FloatingLayer from '../builder/FloatingLayer.js';
import SectionTitle from '../builder/SectionTitle.js';

import SecurityCenterAlerts from './SecurityCenterAlerts.js';
import SecurityCenterDomains from './SecurityCenterDomains.js';
import SecurityCenterMain from './SecurityCenterMain.js';
import SecurityCenterIPs from './SecurityCenterIPs.js';
import SecurityCenterLogs from './SecurityCenterLogs.js';
import { useFilterDataQuery } from '../FilterContent.js';
import SecurityCenterHeaders from './SecurityCenterHeaders.js';


export const SecurityUserAction = (type, ids, data, cb, promotion_id) => {
	SecurityBulkAction(type, cb, ids, data,promotion_id);
};
const SecurityBulkAction = (type, cb, ids, data, promotion_id) => {
//	const owner = useOwner();
//	const promotion = owner?.promotion?.Promotion ?? false;
	var info = { ids:JSON.stringify(ids) };
	switch(type) {
		case 'star':
		case 'unstar':
		case 'block':
		case 'unblock':
		case 'avatar':
			break;
		case 'update_segments':
			info.segment_id = data.segments;
		break;
		case 'edit_user':
			info.data = data;
			info.type = 'only_names';
		break;
	}
	$.post(getRemotedbUrl(`/users/apply_bulk/${type}/${promotion_id}`), info, () => {
		if(cb != undefined) cb(data);
	});
};

export const AlertTypes = [{
	/*k:'csfr',
	v:"No login token",
	color:'orange',
	has_info:true,
	zendesk_link:false,
	what_is:"",
	recommendation:"",
}, {*/
	k:'recaptcha',
	v:"Recaptcha",
	color:'midgray',
	has_info:true,
	zendesk_link:false,
	what_is:"A user has attempted to register but failed to pass the Anti-Bot control based on the reCaptcha system.",
	recommendation:"If you have multiple security alerts and believe they are false positives because the users are legitimate, consider lowering the sensitivity of the control. For example, you can move from a strict level to a medium level or from a medium level to a low level.",
}, {
	k:'disposable',
	v:"Disposable",
	color:'brand',
	has_info:true,
	zendesk_link:false,
	what_is:"A user has attempted to register for the promotion using a temporary or disposable email address. A temporary email is a transient and disposable address, often used to bypass email verification controls. This unethical practice is common in voting contests and promotions that offer direct prizes.",
	recommendation:"You are protected, as this registration attempt has been blocked by the system. However, someone has made a malicious attempt. We recommend clicking on the IP address of the blocked action to analyze if there is more fraudulent activity. If you see users with suspicious emails, you can consider blocking the IP address.",
}, {
	k:'invalid_game',
	v:"Invalid game",
	color:'red',
	has_info:true,
	zendesk_link:false,
	what_is:"A user's participation in a game has been blocked due to anomalous activity, such as using computer programs and techniques to manipulate game timers or scores.",
	recommendation:"This block could be a false positive. Click on the user to analyze their activity. If the user has more than 3 instances of invalid game actions, we recommend blocking the user to prevent further participation.",
}, {
	k:'phone',
	v:"Phone blacklist",
	color:'purple',
	has_info:true,
	zendesk_link:false,
	what_is:"A user has attempted to register with a temporary phone number. There are websites that provide temporary phone numbers and SMS mailboxes, allowing users to avoid using their real phone number to receive SMS validation. This unethical practice is common in voting contests and promotions that offer direct prizes.",
	recommendation:"You are protected since this registration attempt has been blocked by the system. However, someone has made a malicious attempt. We recommend clicking on the IP address of the blocked action to analyze if there is more malicious activity. You can consider blocking the IP to prevent further participation.",
}, {
	k:'ip',
	v:"IP blacklist",
	color:'orange',
	has_info:true,
	zendesk_link:false,
	what_is:"A user has attempted to access the promotion with an IP address that is on your blacklist.",
	recommendation:"You're protected! Users won't be able to access from this IP address, but don't let your guard down because users can use programs to change their IP address. Periodically review the security center information to make sure nothing gets past you.",
}, {
	k:'rules',
	v:"Custom rule",
	color:'yellow',
	has_info:true,
	zendesk_link:false,
	what_is:"A user attempted to register but failed to pass a custom security rule set for your promotion.",
	recommendation:"Periodically check the list of users participating in your promotion to identify suspicious patterns. If you have a custom security rule, it indicates that users may be attempting to cheat your promotion in various ways.",
}];

const AlertInfoLayer = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const zendesk_link = props?.zendesk_link ?? false;

	return (
		<FloatingLayer
			backButton={props.close}
			_class={{ size:'small' }}
		>
			<div class={(zendesk_link === false) ? 'without_actions' : null}>
				<SectionTitle
					autotranslate={false}
				>{i18n("Blocked action")}: {props?.v ?? "Alert"}</SectionTitle>

				{(isNotEmpty(props, 'what_is')) && (
					<div>
						<p><strong>{i18n("What is it?")}</strong></p>

						<p>{i18n(props.what_is)}</p>
					</div>
				)}

				{(isNotEmpty(props, 'recommendation')) && (
					<div class="not_in_top">
						<p><strong>{i18n("Recommendation")}:</strong></p>

						<p>{i18n(props.recommendation)}</p>
					</div>
				)}

				{(zendesk_link !== false) && (
					<ButtonCollection in_floating={true}>
						<SecondaryButton
							_href={`${window.zendesk_base_url}${zendesk_link}`}
							_target='_blank'
						>I want to know more</SecondaryButton>
					</ButtonCollection>
				)}
			</div>
		</FloatingLayer>
	)
};

const SecurityCenter = ({ ...props }) => {
	const owner = useOwner();
	const promotion = owner?.promotion?.Promotion ?? false;
	const [loading_alerts,setLoadingAlerts] = useState(false);

	const getAlerts = (start = false, limit = 100) => {
		setLoadingAlerts(true)
		return $.getJSON(getRemotedbUrl(`/promotions/fetch_alerts/${promotion.id}`), (res)=> {
			setLoadingAlerts(false);
		});
		//return Promise.resolve(props?.alerts ?? { data:[] });
	};
	const [ state_alerts, dispatch_alerts ] = useFilterDataQuery(`alerts${promotion.id}`, getAlerts);
	const alerts = state_alerts.data == undefined ? {data:[]} : state_alerts;
	const [ state, dispatch ] = useReducer((state, action) => {
		switch(action.type) {
			case 'SET_ERRORS':
				return { ...state, errors:action.errors };

			case 'CHANGE_PROMOTION':
				return { ...state, promotion:action.promotion };

			case 'DISPLAY_ALERT_LAYER':
				return { ...state, alert_layer:action.alert_type };

			case 'CHANGE_IP':
				return { ...state, blacklisted_ips:action.ips };

			default:
				return state;
		}
	}, {
		promotion:promotion,
		blacklisted_ips:props?.blacklisted_ips ?? [],
		alert_layer:false,
		errors:{},
	});

	const displayAlertLayer = (alert_type) => {
		dispatch({ type:'DISPLAY_ALERT_LAYER', alert_type });
	};

	const blockDomain = (_domain) => {
		const blacklist_domains = state.promotion?.blacklist_domains ?? [];
		blacklist_domains.push(_domain);
		changePromotion('blacklist_domains', blacklist_domains);
	};

	const unblockDomain = (_domain) => {
		const blacklist_domains = (state.promotion?.blacklist_domains ?? []).filter((d) => (d != _domain));
		changePromotion('blacklist_domains', blacklist_domains);
	};

	const blockIP = (_ip) => {
		const ips = state.blacklisted_ips;
		ips.push(_ip);
		dispatch({ type:'CHANGE_IP', ips });
	};

	const unblockIP = (_ip) => {
		const ips = state.blacklisted_ips.filter((i) => (i != _ip));
		dispatch({ type:'CHANGE_IP', ips });
	};

	const changePromotion = (k, v) => {
		let promotion = state.promotion;
		if(k == 'block_blacklist_text' || k == 'block_blacklist') {
			promotion['config'][k] = v;
		} else {
			promotion[k] = v;
		}
		dispatch({ type:'CHANGE_PROMOTION', promotion });
	};

	return (
		<Router hashType='noslash'>
			<Route path="/(main|)" exact={true} render={(route) => {
				return (
					<OwnerPromoWrapper
						add_module={false}
						{...props}
						simple_header={true}
						menu='security'
						selected='main'
					>
						<SecurityCenterMain />
					</OwnerPromoWrapper>
				)
			}} />

			<Route path="/alerts" render={(route) => {
				return (
					<OwnerPromoWrapper
						add_module={false}
						{...props}
						simple_header={true}
						menu='security'
						selected='alerts'
					>
						<SecurityCenterAlerts
							alerts={alerts}
							loading={loading_alerts}
							blacklisted_ips={state.blacklisted_ips}
							onBlock={blockIP}
							onUnblock={unblockIP}
							openAlertLayer={displayAlertLayer}
						/>

						{(state.alert_layer != false) && (
							<AlertInfoLayer
								{...AlertTypes.find((t) => (t.k == state.alert_layer))}
								close={() => displayAlertLayer(false)}
								intl={props.intl}
							/>
						)}
					</OwnerPromoWrapper>
				)
			}} />

			<Route path="/domains" render={(route) => {
				return (
					<OwnerPromoWrapper
						add_module={false}
						{...props}
						simple_header={true}
						menu='security'
						selected='domains'
					>
						<SecurityCenterDomains
							alerts={alerts}
							loading={loading_alerts}
							domains={props.domains}
							total_users={props.total_users}
							promotion={state.promotion}
							onBlock={blockDomain}
							onUnblock={unblockDomain}
						/>
					</OwnerPromoWrapper>
				)
			}} />

			<Route path="/ips" render={(route) => {
				return (
					<OwnerPromoWrapper
						add_module={false}
						{...props}
						simple_header={true}
						menu='security'
						selected='ips'
					>
						<SecurityCenterIPs
							alerts={alerts}
							loading={loading_alerts}
							ips={props.ips}
							total_users={props.total_users}
							total_participants={props.total_participants}
							blacklisted_ips={state.blacklisted_ips}
							onBlock={blockIP}
							onUnblock={unblockIP}
						/>
					</OwnerPromoWrapper>
				)
			}} />

			<Route path="/logs" render={(route) => {
				return (
					<OwnerPromoWrapper
						add_module={false}
						{...props}
						simple_header={true}
						menu='security'
						selected='logs'
					>
						<SecurityCenterLogs
							agents={props?.agents ?? []}
						/>
					</OwnerPromoWrapper>
				)
			}} />

			<Route path="/security-headers" >
				<OwnerPromoWrapper
					add_module={false}
					{...props}
					simple_header={true}
					menu='security'
					selected='security-headers'
				>
					<SecurityCenterHeaders 
						promotion={state.promotion} 
						changePromotion={changePromotion}
					/>
				</OwnerPromoWrapper>
			</Route>
				
				
			
		</Router>
	);
}

export default injectIntl(SecurityCenter);